// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s8kK","col":"styles_col__2tstC","actions":"styles_actions__1Sx5u","conflict":"styles_conflict__14uy4"};